import React, { useState, useCallback } from 'react';
import { BaseProperty } from '../types';
import { Competitor } from '@/features/compset/types';

export interface UsePropertyVisibilityReturn {
  visiblePropertyIds: number[];
  togglePropertyVisibility: (propertyId: number) => void;
  toggleAllProperties: (showAll: boolean, properties: (BaseProperty | Competitor)[], mainPropertyId?: number) => void;
}

export const usePropertyVisibility = (): UsePropertyVisibilityReturn => {
  const [visiblePropertyIds, setVisiblePropertyIds] = useState<number[]>([]);

  const togglePropertyVisibility = useCallback((propertyId: number) => {
    setVisiblePropertyIds(prev =>
      prev.includes(propertyId)
        ? prev.filter(id => id !== propertyId)
        : [...prev, propertyId]
    );
  }, []);

  const toggleAllProperties = useCallback((
    showAll: boolean,
    properties: (BaseProperty | Competitor)[],
    mainPropertyId?: number
  ) => {
    if (showAll) {
      // Show all properties in the chart
      setVisiblePropertyIds(properties
        .filter(p => p.property_id !== mainPropertyId) // Filter out main property 
        .map(p => p.property_id)
      );

      // Always include the main property
      if (mainPropertyId) {
        setVisiblePropertyIds(prev =>
          prev.includes(mainPropertyId) ? prev : [...prev, mainPropertyId]
        );
      }
    } else {
      // Show only main property
      setVisiblePropertyIds(mainPropertyId ? [mainPropertyId] : []);
    }
  }, []);

  return {
    visiblePropertyIds,
    togglePropertyVisibility,
    toggleAllProperties,
  };
};